/* eslint-disable */
import { getHistoricalChartsTitle, getHistoricalChartsYAxisTitle } from "../../utils/helper";
import Spinner from 'components/common/spinner/spinner';


export const displayNoData = (activity) => {
    return (
        <div>
            <div className="player-profile-analytics-title">
                <p style={{ display: 'inline', position: 'relative', bottom: '-6px', marginLeft: '20px' }}>
                    {activity?.name}
                </p>
            </div>

            <div className="no-data-container">
                No Data Available For This Metric
            </div>
        </div>
    )
}


export const displayLoadingCharts = (activity) => {
    return (
        <div className="player-profile-analytics-title" style={{ justifyContent: 'center' }}>

            <p style={{ display: 'inline', position: 'relative', bottom: '-6px', marginLeft: '20px' }}>
                {activity?.name ? activity.name : activity}
            </p>

            <div className="metric-container" style={{ marginTop: '20px' }}>

                <Spinner cls='spinner-user-profile' classnames={'user-profile-loader'} />

            </div>
        </div>
    )
}


export const getLatestChange = (activity, userData) => {

    if (activity.bilateral === 1) {
        let chartData = []
        if (userData.activityObject['activity' + activity.id]) {
            chartData = userData.activityObject['activity' + activity.id].chartData
        }

        if (chartData && chartData.length > 1) {

            let averageValue = chartData.map(item => item.value).reduce((a, b) => a + b, 0) / chartData.length;
            let lastItem = chartData[0]?.value

            let diff = (lastItem - averageValue).toFixed(2)

            return ((diff / averageValue) * 100).toFixed(2)
        }
    }

    return null
}


export const getUnit = (activity) => {

    if (getHistoricalChartsTitle(activity.id).toLocaleLowerCase() === "Jump Height".toLocaleLowerCase()) {
        return "cm"
    }
}
